/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Link } from '@coursera/cds-core';

import _t from 'i18n!nls/enroll-course';

export const getStandaloneCourseEnrollModalCopy = ({
  courseName,
  price,
  secondaryCtaAction,
}: {
  courseName: string;
  price: React.ReactNode;
  secondaryCtaAction: (e: React.SyntheticEvent<HTMLButtonElement>) => void;
}) => {
  return {
    headerMessage: courseName,
    bodyMessage: (
      <FormattedMessage
        message={_t(
          `This course costs {productPrice}. Start your learning journey now and master the material in this course to earn a certificate that showcases your knowledge and achievement.`
        )}
        productPrice={price}
      />
    ),
    primaryCta: _t(`Continue`),
    secondaryCta: (
      <FormattedMessage
        message={_t('{preview} this course')}
        preview={
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <Link component="button" onClick={secondaryCtaAction}>
            {_t('Preview')}
          </Link>
        }
      />
    ),
  };
};
